import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const useMockData = false
const resource = 'esg'

const mockSource = [
  { id: 'esg-1', title_th: 'กิจกรรมปลูกป่า', title_en: 'Tree Planting Activity', description_th: 'กิจกรรมเพื่อความยั่งยืน', description_en: 'Sustainability activity', banner_url: 'https://obs.example.com/esg/e1.jpg', event_date: '2026-09-01', updated_at: '2026-09-30T09:00:00Z' }
]

const defaultState = () => ({ currentPage: 1, pageSize: 10, total: 0, sortBy: 'updated_at', sortDesc: 'DESC', textSearch: '', list: [], isLoading: false, isSaving: false })
const state = defaultState()
const generateMockId = (prefix) => `${prefix}-${Date.now()}-${Math.floor(Math.random() * 100000)}`

const actions = {
  async upload(_, payload) {
    try {
      const response = await client.secureHttpClient.post('/por/api/upload/obs', payload)
      return response?.data?.url || response?.data?.data?.url || ''
    } catch (e) {
      Vue.$log.error(e)
      return ''
    }
  },
  setResource() {}, setTextSearch({commit}, text) { commit('SET_TEXT_SEARCH', text) },
  async fetch({commit, state}) {
    commit('SET_IS_LOADING', true)
    if (useMockData) {
      let data = [...mockSource]
      if (state.textSearch) {
        const term = state.textSearch.toLowerCase()
        data = data.filter(item => `${item.title_th || ''} ${item.title_en || ''}`.toLowerCase().includes(term))
      }
      commit('SET_LIST', data); commit('SET_TOTAL', data.length); commit('SET_IS_LOADING', false); return
    }
    try {
      const response = await client.secureHttpClient.get(`/por/api/${resource}`, { params: { page: state.currentPage, limit: state.pageSize, orderBy: state.sortBy, sort: state.sortDesc, search: state.textSearch }, paramsSerializer: localParams => qs.stringify(localParams, {encode: false}) })
      const resData = response?.data || {}
      const list = resData.results || resData.data || []
      const total = resData.total !== undefined ? resData.total : list.length
      commit('SET_LIST', Array.isArray(list) ? list : [])
      commit('SET_TOTAL', total)
    } catch (e) { Vue.$log.error(e); commit('SET_LIST', []); commit('SET_TOTAL', 0) }
    commit('SET_IS_LOADING', false)
  },
  async save({commit}, payload) {
    commit('SET_IS_SAVING', true)
    if (useMockData) {
      if (payload.id) {
        const index = mockSource.findIndex(item => item.id === payload.id)
        if (index !== -1) mockSource[index] = {...mockSource[index], ...payload, updated_at: new Date().toISOString()}
      } else {
        mockSource.unshift({...payload, id: generateMockId('esg'), updated_at: new Date().toISOString()})
      }
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    }
    try {
      if (payload.id) await client.secureHttpClient.put(`/por/api/${resource}/${payload.id}`, payload)
      else await client.secureHttpClient.post(`/por/api/${resource}`, payload)
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    } catch (e) { Vue.$log.error(e); commit('SET_IS_SAVING', false); return {ok: false, message: e?.response?.data?.message || 'Unable to save'} }
  },
  async deleteById(_context, id) {
    if (useMockData) { const index = mockSource.findIndex(item => item.id === id); if (index !== -1) mockSource.splice(index, 1); return true }
    try { await client.secureHttpClient.delete(`/por/api/${resource}/${id}`); return true } catch (e) { Vue.$log.error(e); return false }
  }
}

const mutations = {
  SET_TEXT_SEARCH(state, text) { state.textSearch = text }, SET_LIST(state, list) { state.list = list }, SET_TOTAL(state, total) { state.total = total }, SET_IS_LOADING(state, isLoading) { state.isLoading = isLoading }, SET_IS_SAVING(state, isSaving) { state.isSaving = isSaving }
}

export default { namespaced: true, state, actions, mutations }
